const apiUrl = process.env.REACT_APP_API_URL;
export const GetLlocTreball = async ( page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/lloctreball`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
